import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import { NgxSpinnerService } from 'ngx-spinner';
import * as moment from 'moment';

import {
  FormModeEnum,
  ToolbarItem,
  TableActionParams,
  NotificationService,
  ModalService,
  BackendService,
  FieldStructure,
  TableSettings,
  TableActionEnum,
  FilterSettings,
  CustomModalService,
} from 'beyond-util';
import { SifarnikBase } from '../sifarnik-base/sifarnik-base';
import { FormCode } from '../../../enums/form-code.enum';
import { FormName } from '../../../enums/form-name.enum';
import { EndpointTypes } from '../../../enums/enpoint-types.enum';
import { BackendService as RtsBackendService } from '../../../services/backend.service';
import { ActionType } from '../../../enums/action-type.enum';
import { ValidationService } from '../../../services/validation.service';
import { EnumService } from '../../../services/enum.service';
import { SpotActiveTab } from './active-tab.enum';
import { SpotoviService } from '../../../services/spotovi.service';
import { environment } from '../../../../environments/environment';

declare var VideoFrame: any;

@Component({
  selector: 'app-spotovi',
  templateUrl: './spotovi.component.html',
})
export class SpotoviComponent extends SifarnikBase
  implements OnInit, OnDestroy {
  private _subscriptions: Array<Subscription> = [];
  private _data: Array<any>;

  public showDetails = false;

  public settingsTableFonogramDetails: TableSettings;
  public settingsTableBrendDetails: TableSettings;
  public settingsTableZabraneDetails: TableSettings;

  public brendoviList: Array<any> = [];
  public zabraneList: Array<any> = [];
  public fonogramiList: Array<any> = [];

  public SpotActiveTab = SpotActiveTab;
  public activeTab = SpotActiveTab.Brendovi;

  public validateSubject: Subject<any> = new Subject<any>();
  public validateSubject$ = this.validateSubject.asObservable();

  public spotoviTableSettings: TableSettings;
  public spotoviFilterSettings: FilterSettings;

  private _brendoviListBeforeEditing: any;
  private _zabraneListBeforeEditing: any;
  private _fonogramiListBeforeEditing: any;
  private Privilegije: Array<string> = [];
  public prefiksi: Array<string> = ["S", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "T", "U", "V", "W", "X", "Y", "Z"];

  public frameRateSettings: any;

  public video;
  public frameRate = this._enumService.getDefaultFrameRate();
  public duration;
  public videoUrl;
  showVideo;

  public uradiObracun = false;

  private readonly trajanjeSpotaVeceOdNulaMsg =
    'Trajanje spota mora biti veće od 0.';

  private readonly parseXmlsPayload = this._rtsBackendService.getRequestPayload(
    FormCode.MSAIS_AIS,
    FormName.AvecoParser,
    EndpointTypes.AllEntities,
    null,
    null,
    null,
    true
  );

  get videoSMPTE() {
    return this.video ? this.video.toSMPTE() : null;
  }

  get videoFrame() {
    return this.video ? this.video.get() : null;
  }

  constructor(
    protected _backendService: BackendService,
    protected _modalService: ModalService,
    protected _notificationService: NotificationService,
    private _rtsBackendService: RtsBackendService,
    private _validationService: ValidationService,
    private _enumService: EnumService,
    private _customModalService: CustomModalService,
    private _spotoviService: SpotoviService,
    private _spinner: NgxSpinnerService
  ) {
    super(_backendService, _modalService, _notificationService);
  }

  ngOnInit() {
    setTimeout(() => {
      this._spinner.show();
      this.order = {};
      super.ngOnInit();
      this._enumService.fetchVrstaZabrane();
      this._enumService.fetchVrstaSpota();
      this._enumService.fetchVrsteMedija();
      this._enumService.registerSpotFrameRates();
      this.setSpotFrameRatesSettings();
    });
  }

  ngOnDestroy() {
    this._subscriptions.forEach((s: Subscription) => s.unsubscribe());
  }

  setTab(tab: SpotActiveTab) {
    this.activeTab = tab;
  }

  changeName() {
    if (typeof this.order === 'undefined') {
      return;
    }

    if (this.order.hasOwnProperty('naziv')) {
      this.name = this.order.naziv;
    } else if (this.mode === FormModeEnum.Add) {
      this.name = 'Novi spot';
    } else if (this.order.hasOwnProperty('id')) {
      this.name = 'Spotovi';
    }
  }

  setSpotFrameRatesSettings() {
    const settings = this._spotoviService.getSpotFrameRatesSettings();
    const settingsTable = new TableSettings(settings, 'table');

    this.frameRateSettings = settingsTable.getFieldByName('FrameRate');
  }

  onDeleteConfirm() {
    this._spinner.show();
    this._subscriptions.push(
      this._rtsBackendService
        .delete(FormCode.MSSPO_SPO, FormName.PregledSpotova, this.order.Id)
        .subscribe((data: any) => {
          if (data && data.Error) {
            this._notificationService.notyError(data.Error.ErrorMessage);
            this._spinner.hide();

            return;
          }
          this._notificationService.openNoty('Uspešno brisanje');
          this.changeMode(FormModeEnum.Table);
          this.loadSettings();
        })
    );
  }

  addOrder() {
    this.setActionType(ActionType.Create);
    this.validateSubject.next();
  }

  create() {
    if (!this.validateNumbers()) {
      this.notify('Niste uneli dobar format za trajanje.');

      return;
    }

    if (+this.order.TrajanjeSekunde <= 0) {
      this.notify(this.trajanjeSpotaVeceOdNulaMsg);

      return;
    }

    if (this.isNotNumeric(this.order.KobrendingUvecanje)) {
      this.notify(
        'Kobrending uvećanje (%)" može da sadrži samo decimalni broj.'
      );

      return;
    }

    this._spinner.show();
    const payload = this.getPayload();
    this.mapPayloadDetails(payload);
    this._subscriptions.push(
      this._rtsBackendService
        .save(FormCode.MSSPO_SPO, FormName.PregledSpotova, payload)
        .subscribe((response: any) => {
          this._spinner.hide();
          if (this.openServiceError(response)) {
            return;
          }

          if (response.ServiceData.Sifra !== payload.Sifra) {
            this._notificationService.openNoty(
              `Prilikom snimanja spota došlo je do promene u šifri spota, novi spot je snimljen sa šifrom ${response.ServiceData.Sifra}.`
            );
          }

          this.loadSettings();
        })
    );
  }

  getPayload() {
    const payload = { ...this.order };
    payload.VrstaMedijaNaziv = this._enumService.vrsteMedija.find(
      x => x.Id === this.order.VrstaMedijaId
    ).Naziv;

    return payload;
  }

  updateOrder() {
    this.setActionType(ActionType.Update);
    this.validateSubject.next();
  }

  update() {
    if (!this.validateNumbers()) {
      this.notify('Niste uneli dobar format za trajanje.');

      return;
    }

    if (+this.order.TrajanjeSekunde <= 0) {
      this.notify(this.trajanjeSpotaVeceOdNulaMsg);

      return;
    }

    if (this.isNotNumeric(this.order.KobrendingUvecanje)) {
      this.notify(
        'Kobrending uvećanje (%)" može da sadrži samo decimalni broj.'
      );

      return;
    }

    this.getSpecifikacijeZaBrisanje().subscribe(response => {
      const spotSpecifikacije = response.ServiceData;
      let obrisi = false;
      let specifikacije: any[] = [];
      if (spotSpecifikacije) {
        obrisi = spotSpecifikacije.PostojiSpecifikacija;
        specifikacije = spotSpecifikacije.Specifikacije;
      }

      if (obrisi) {
        this._modalService.openModal(
          this.getPorukuOSpecifikacijamaZaBrisanje(specifikacije),
          confirmed => {
            this.updateSpot(confirmed);
          }
        );
      } else {
        this.updateSpot(false);
      }
    });
  }

  getPorukuOSpecifikacijamaZaBrisanje(specifikacije: any[]) {
    return `Potvrdom ćete obrisati dokumente specifikacija emitovanja: ${specifikacije.join(
      ','
    )}.`;
  }

  updateSpot(obrisiSpecifikacije: boolean) {
    this._spinner.show();
    const payload = this.getPayload();
    payload.ObrisiSpecifikacije = obrisiSpecifikacije;

    this.mapPayloadDetails(payload);
    this._subscriptions.push(
      this._rtsBackendService
        .update(FormCode.MSSPO_SPO, FormName.PregledSpotova, payload)
        .subscribe(data => {
          this.openServiceError(data);
          this.loadSettings();
          this.openObrisaneSpecifikacijeDokumenti(data);
        })
    );
  }

  getSpecifikacijeZaBrisanje(): Observable<any> {
    const payload = this._rtsBackendService.getRequestPayload(
      FormCode.MSMP_PROSPEC,
      FormName.PregledSpotova,
      EndpointTypes.SingleEntity,
      `?spotId=${this.order.Id}`,
      null,
      null,
      true
    );

    return this._rtsBackendService.fetchMediaPlanSettings(payload);
  }

  openObrisaneSpecifikacijeDokumenti(response) {
    const spot = response.ServiceData;
    if (spot && spot.ObrisaneSpecifikacije) {
      return this._notificationService.openNoty(spot.ObrisaneSpecifikacije);
    }
  }

  onTableActionFilter(event: any) {
    this._spinner.show();
    super.onTableActionFilter(event);
  }

  validateNumbers() {
    return this._validationService.validateNumber(this.order.TrajanjeSekunde);
  }

  notify(message: string) {
    this._notificationService.notyError(message);
  }

  mapPayloadDetails(payload: any) {
    payload.Brendovi = this.brendoviList;
    if (this.zabraneList && this.zabraneList.length > 0) {
      payload.Zabrane = this.zabraneList.map(z => z.Naziv);
    } else {
      payload.Zabrane = [];
    }
    payload.Fonogrami = this.fonogramiList;
  }

  loadSettings() {
    this._subscriptions.push(
      this._rtsBackendService
        .fetchSettings(
          FormCode.MSSPO_SPO,
          FormName.PregledSpotova,
          EndpointTypes.AllEntities,
          this.filterQuery
        )
        .subscribe(data => {
          const settings = data.Settings;

          this._spinner.hide();
          this.changeFilterSettings(settings);
          this.disableInlineActions(settings);
          this.removeDbTypeFromField(settings, 'VremeProvereVideoServera');
          this.setSettings(settings);
          this._data = data.ServiceData.Data;
          this._dataCount = data.ServiceData.DataSumCount;
          this.setAllFields(this.spotoviFilterSettings);
          this.refreshTable();
        })
    );
  }

  removeDbTypeFromField(settings, fieldName) {
    settings.allFields.find(f => f.fieldKey === fieldName).dbType = '';
  }

  setSettings(allSettings: any) {
    this.spotoviTableSettings = new TableSettings(allSettings, 'table');
    this.spotoviFilterSettings = new FilterSettings(allSettings);
  }

  changeFilterSettings(settings) {
    const vzIndex = settings.filterFields.findIndex(
      f => f.name === 'VrstaZabraneId'
    );
    const spotoviIndex = settings.filterFields.findIndex(
      f => f.name === 'SviSpotovi'
    );
    settings.filterFields.splice(spotoviIndex, 1);
    const vz = settings.filterFields.find(f => f.name === 'VrstaZabraneId');
    settings.filterFields.splice(vzIndex, 1);
    settings.filterFields.splice(3, 0, vz);
  }

  refreshTable() {
    this.setId(this._data);
    this.orderListCount = this._dataCount;
    this.orderList = this._data;
  }

  brendTableAction(event) {
    switch (event.action) {
      case TableActionEnum.Save:
        event.document.Trajanje = +event.document.Trajanje;
        break;
      case TableActionEnum.EditCancel:
        if (this.brendoviList.some(a => a['rbr'] === event.document.rbr)) {
          this.copyProperties(
            event.document,
            this.brendoviList.filter(a => a['rbr'] === event.document.rbr)[0]
          );
        }
        break;
    }
  }

  onTableActionUpdate(event: TableActionParams) {
    super.onTableActionUpdate(event);
    this.refreshTable();
  }

  onTableActionView() {
    this.fetchDetails();
    this.changeMode(FormModeEnum.View);
    this.setTab(SpotActiveTab.Brendovi);
  }

  onViewMode() {
    this.showVideo = false;
    //this.order.StariSpot = !this.order.Sifra.startsWith('S');
    for(let i = 0; i < this.prefiksi.length; i++) {
      if(!this.order.Sifra.startsWith(this.prefiksi[i])) {
        this.order.StariSpot = false;
      }
      else {
        this.order.StariSpot = true;
      }
    }
    this.video = null;
    this.setToolbar();
  }

  setToolbar(isPrisutan: boolean = false) {
    const toolbarItems: ToolbarItem[] = [];

    toolbarItems.push(ToolbarItem.PogledajSpot(true, isPrisutan));
    toolbarItems.push(ToolbarItem.ProveriVideoServer());
    if (this.Privilegije.includes('MSSPO_SPO_CREATE')) {
      toolbarItems.push(ToolbarItem.ItemAdd(true, true, null, 'Dodaj'));
    }
    if (this.Privilegije.includes('MSSPO_SPO_UPDATE')) {
      toolbarItems.push(ToolbarItem.ItemEdit(true, true, null, 'Izmeni'));
    }
    if (this.Privilegije.includes('MSSPO_SPO_DELETE')) {
      toolbarItems.push(ToolbarItem.ItemDelete());
    }

    this.setToolbarOptions({
      items: toolbarItems,
    });
  }

  getCheckVSObservable(): Observable<any> {
    return this._rtsBackendService.fetchMediaPlanSettings(
      this.getCheckVSPayload()
    );
  }

  checkVS() {
    this._subscriptions.push(
      this.getCheckVSObservable().subscribe((data: any) => {
        this.onCheckVS(data);
      })
    );
  }

  onCheckVS(data) {
    if (data['Errors'][0] && data['Errors'][0]['ErrorMessage']) {
      this.notifyError(data['Errors'][0]['ErrorMessage']);

      return;
    }
    const prisutan: boolean = data.ServiceData.IsPresent;

    if (this.mode === FormModeEnum.Edit || this.mode === FormModeEnum.View) {
      this.setToolbar(prisutan);
      this.notyPrisutanNaVS(prisutan);
    }

    this.updatePrisutnostNaVS(data.ServiceData);
  }

  pogledajSpot() {
    this.openModal();
    this.videoUrl = `${environment.videoUrl}/Spot?sifra=${this.order.Sifra}`;
    this.showVideo = true;

    setTimeout(() => {
      this.initVideo();
    }, 5000);
  }

  initVideo() {
    this.video = VideoFrame({
      id: 'videoFrame',
      frameRate: this.frameRate,
      callback: function(response) {},
    });

    if (this.video) {
      this.video.listen('frame');
    }
  }

  seekTo(end?: boolean) {
    const element: any = document.getElementById('videoFrame');
    if (element) {
      this.duration = element.duration;
      element.currentTime = end ? Math.round(this.duration * 100) / 100 : 0;
    }
  }

  onFrameRateChange(event: any) {
    this.frameRate = event.value;
    this.video.frameRate = this.frameRate;
  }

  kopirajNaSpot() {
    if (this.videoSMPTE !== '00:00:00:00') {
      this.uradiObracun = this.videoSMPTE !== this.order.VremeTrajanjaServer;
      this.order.VremeTrajanjaServer = this.videoSMPTE;
      if (this.order.VremeTrajanjaServer) {
        this._spinner.show();
        this.updateTrajanjeVideoServer();
      }
      this.fieldStructure.getFieldByName(
        'TrajanjeSekunde'
      ).editable = !this.isTrajanjeEditable();
      this.fieldStructure.getFieldByName(
        'TrajanjeSekunde'
      ).additable = !this.isTrajanjeEditable();
      this.closeModal();
    }

    this.closeModal();
  }

  openModal() {
    this._customModalService.open('custom-video-modal');
  }

  closeModal() {
    this._customModalService.close('custom-video-modal');
    this.showVideo = false;
    if (this.video) {
      this.video.stopListen();
    }
  }

  notyPrisutanNaVS(prisutan: boolean) {
    if (prisutan) {
      this._notificationService.openNoty(
        `Spot "${this.order.Sifra}" se nalazi na video serveru.`
      );
    } else {
      this._notificationService.openNoty(
        `Spot "${this.order.Sifra}" se ne nalazi na video serveru.`
      );
    }
  }

  onSave() {
    // if (this.order.StariSpot) {
    //   this.getCheckVSObservable().subscribe(data => {
    //     this.onCheckVS(data);
    //     if (!data.ServiceData.IsPresent) {
    //       this.notifyError('Stari spot se ne nalazi na video serveru.');
    //     } else {
    //       super.onSave();
    //     }
    //   });
    // } else {
    if (
      this.mode === FormModeEnum.Edit &&
      isFinite(this.order.TrajanjeSekunde) &&
      +this.order.TrajanjeSekunde > 0 &&
      this._orderBeforeEditing.TrajanjeSekunde !== +this.order.TrajanjeSekunde
    ) {
      this.order.UradiObracun = true;
    }
    super.onSave();
  }

  private getCheckVSPayload() {
    return this._rtsBackendService.getRequestPayload(
      FormCode.MSAIS_CHECK,
      FormName.AvecoParser,
      EndpointTypes.SingleEntity,
      `?sifra=${this.order.Sifra}`
    );
  }

  private getUpdateVSTrajanjePayload() {
    const entity = {
      Id: this.order.Id,
      VremeTrajanjaServer: this.order.VremeTrajanjaServer,
      UradiObracun: this.uradiObracun,
    };

    return this._rtsBackendService.getRequestPayload(
      FormCode.MSSPO_VST,
      FormName.PregledSpotova,
      EndpointTypes.PutEntity,
      null,
      entity,
      true
    );
  }

  updatePrisutnostNaVS(spotInfo: any) {
    spotInfo.SpotSifra = this.order.Sifra;
    spotInfo.Id = this.order.Id;

    const payload = { ...spotInfo };

    this._subscriptions.push(
      this._rtsBackendService
        .update(FormCode.MSSPO_UPDPR, FormName.PregledSpotova, payload)
        .subscribe((data: any) => {
          const resp = data.ServiceData;
          if (resp.SpotSifra) {
            this.order.VremeProvereVideoServera = moment(
              resp.VremeProvereVideoServera
            ).format('DD.MM.YYYY HH:mm');
            this.order.JePrisutanNaVideoServeru = resp.IsPresent;
          }
        })
    );
  }

  updateTrajanjeVideoServer() {
    this._subscriptions.push(
      this._rtsBackendService
        .fetchMediaPlanSettings(this.getUpdateVSTrajanjePayload())
        .subscribe((response: any) => {
          this._spinner.hide();
          if (response.ServiceData) {
            this.order.TrajanjeSekunde = response.ServiceData.TrajanjeSekunde;
            this._notificationService.openNoty(
              'Uspešno ažurirano vreme trajanja na serveru.'
            );
          }
        })
    );
  }

  onTableActionAdd() {
    this.fetchDetails();
    this.changeMode(FormModeEnum.Add);
  }

  onFonogramTableAction(event: TableActionParams) {
    if (
      event.action === TableActionEnum.Save ||
      event.action === TableActionEnum.Update
    ) {
      this.mapStringToNumber(this.fonogramiList, 'Trajanje', event.document);
    }

    if (event.action === TableActionEnum.EditCancel) {
      if (this.fonogramiList.some(a => a['rbr'] === event.document['rbr'])) {
        this.copyProperties(
          event.document,
          this.fonogramiList.filter(a => a['rbr'] === event.document['rbr'])[0]
        );
      }
    }
  }

  spotValueChanged(event) {
    if (event.newValue || event.fieldMap.fieldKey === 'StariSpot') {
      switch (event.fieldMap.fieldKey) {
        case 'VrstaSpotaId':
          if (this.order.VrstaSpotaId === 2) {
            this.fieldStructure.getFieldByName('Klijent').mandatory = false;
          } else {
            this.fieldStructure.getFieldByName('Klijent').mandatory = true;
          }
          break;
        case 'StariSpot':
          if (this.mode === FormModeEnum.Add) {
            if (!event.newValue) {
              this.generisiSifru();
              // this.fieldStructure.getFieldByName('Sifra').visible = false;
              this.fieldStructure.getFieldByName('Sifra').editable = false;
            } else {
              // this.fieldStructure.getFieldByName('Sifra').visible = true;
              this.fieldStructure.getFieldByName('Sifra').editable = true;
              this.order.Sifra = '';
            }
            break;
          }
      }
    }
  }

  generisiSifru() {
    this._subscriptions.push(
      this._rtsBackendService
        .fetchSettings(
          FormCode.MSSPO_SIFRA,
          FormName.PregledSpotova,
          EndpointTypes.SingleEntity,
          '',
          null,
          true
        )
        .subscribe(data => (this.order.Sifra = data.ServiceData[0]))
    );
  }

  fetchDetails() {
    this.fetchSingleEntity(FormCode.MSSPO_SPO);
    this._enumService.fetchVrstaZabraneZaSpotId(this.order.Id);
    // this._enumService.fetchStanjeSpotaZaSpotId(this.order.Id);
  }

  fetchSingleEntity(formCode: FormCode) {
    this._spinner.show();
    this._subscriptions.push(
      this._rtsBackendService
        .fetchSettings(
          formCode,
          FormName.PregledSpotova,
          EndpointTypes.SingleEntity,
          '',
          this.order.Id ? this.order.Id : null
        )
        .subscribe(data => {
          this._spinner.hide();
          this.removeDbTypeFromField(data.Settings, 'VremeProvereVideoServera');
          this.splitDetails(data.Settings, 9);
          this.fieldStructure = new FieldStructure(data.Settings, 'header');
          this.order = this.order.Id ? data.ServiceData[0] : {};
          this.alterFieldStructure();
          this.setDetailsTableSettings(data);
          this.mapDetailsLists(data);
          this.showDetails = true;
          this.Privilegije = data.Privilegije;
          if (!this.order.Id) {
            this.order = {
              DatumKreiranja: new Date(),
              DatumPrijema: new Date(),
            };
          }
          this.setInfobar(true, 'Milenković Marina', this.order.DatumIzmene);
          this.formatDate();

          this.openDetails();
        })
    );
  }

  private openDetails() {
    if (this.order.Id) {
      this.onViewMode();
      if (this.order.VrstaSpotaId === 2) {
        this.fieldStructure.getFieldByName('Klijent').mandatory = false;
      } else {
        this.fieldStructure.getFieldByName('Klijent').mandatory = true;
      }
    } else {
      this.generisiSifru();
    }
  }

  formatDate() {
    if (!this.order.VremeProvereVideoServera) {
      return;
    }

    const datumProvere = moment(this.order.VremeProvereVideoServera).format(
      'DD.MM.YYYY HH:mm'
    );

    this.order.VremeProvereVideoServera = datumProvere;
  }

  alterFieldStructure() {
    this.fieldStructure.getFieldByName('BrojRezervacija').editable = false;
    this.fieldStructure.getFieldByName('BrojRezervacija').additable = false;
    this.fieldStructure.getFieldByName('VremeTrajanjaServer').editable = false;
    this.fieldStructure.getFieldByName('VremeTrajanjaServer').additable = false;
    this.fieldStructure.getFieldByName(
      'JePrisutanNaVideoServeru'
    ).editable = false;
    this.fieldStructure.getFieldByName(
      'JePrisutanNaVideoServeru'
    ).additable = false;
    this.fieldStructure.getFieldByName('DatumKreiranja').editable = false;
    this.fieldStructure.getFieldByName('DatumKreiranja').additable = false;
    this.fieldStructure.getFieldByName(
      'TrajanjeSekunde'
    ).editable = !this.isTrajanjeEditable();
    this.fieldStructure.getFieldByName(
      'TrajanjeSekunde'
    ).additable = !this.isTrajanjeEditable();

    // this.fieldStructure.getFieldByName('Sifra').visible = this.order.StariSpot;
  }

  setDetailsTableSettings(data) {
    data.Settings.details[0].allFields[2].path = 'Naziv';

    data.Settings.details[0].allFields[3].editable = false;
    data.Settings.details[1].allFields[2].editable = false;
    data.Settings.details[1].allFields[3].editable = false;

    this.settingsTableBrendDetails = new TableSettings(
      data.Settings.details[0],
      'table'
    );

    this.settingsTableZabraneDetails = new TableSettings(
      data.Settings.details[1],
      'table'
    );
    this.settingsTableFonogramDetails = new TableSettings(
      data.Settings.details[2],
      'table'
    );
  }

  brendoviValueChanged(event) {
    if (event.newValue && event.fieldMap.fieldKey === 'Naziv') {
      const index = this.brendoviList.findIndex(b => {
        return b.rbr === event.order.rbr;
      });

      const value = { ...event.newValue };
      this.brendoviList[index].Naziv = value.Naziv;
      this.brendoviList[index].Opis = value.Opis;
      this.brendoviList[index].Id = value.Id;
    }
  }

  zabraneTableAction(event) {
    switch (event.action) {
      case TableActionEnum.EditCancel:
        if (this.zabraneList.some(a => a['rbr'] === event.document['rbr'])) {
          this.copyProperties(
            event.document,
            this.zabraneList.filter(a => a['rbr'] === event.document['rbr'])[0]
          );
        }
    }
  }

  onAddMode() {
    super.onAddMode();
  }

  onEditMode() {
    this._orderBeforeEditing = { ...this.order };
    this._brendoviListBeforeEditing = this.deepCopyFunction(this.brendoviList);
    this._zabraneListBeforeEditing = this.deepCopyFunction(this.zabraneList);
    this._fonogramiListBeforeEditing = this.deepCopyFunction(
      this.fonogramiList
    );

    this.fieldStructure.getFieldByName('StariSpot').additable = false;
    this.fieldStructure.getFieldByName('StariSpot').editable = false;

    this.setToolbarOptions({
      items: [ToolbarItem.ItemSave(), ToolbarItem.ItemCancel()],
    });
  }

  onCancel() {
    this.order = { ...this._orderBeforeEditing };
    this.brendoviList = this.deepCopyFunction(this._brendoviListBeforeEditing);
    this.zabraneList = this.deepCopyFunction(this._zabraneListBeforeEditing);
    this.fonogramiList = this.deepCopyFunction(
      this._fonogramiListBeforeEditing
    );

    this.changeMode(FormModeEnum.View);
  }

  onClose() {
    this.loadSettings();
    this.order = {};
    this.changeMode(FormModeEnum.Table);
  }

  mapDetailsLists(data: any) {
    if (this.order.Id) {
      this.brendoviList = data.ServiceData[0].Brendovi;
      const zabrane: any[] = data.ServiceData[0].Zabrane;
      if (zabrane && zabrane.length) {
        this.zabraneList = zabrane.map(z => {
          return {
            Naziv: z.Id,
            Opis: z.Opis,
          };
        });
      } else {
        this.zabraneList = [];
      }
      this.fonogramiList = data.ServiceData[0].Fonogrami;

      this.setRbr(this.brendoviList);
      this.setRbr(this.zabraneList);
      this.setRbr(this.fonogramiList);
    } else {
      this.fonogramiList = [];
      this.brendoviList = [];
      this.zabraneList = [];
    }
  }

  isTrajanjeEditable(): boolean {
    return (
      this.order.VremeTrajanjaServer &&
      this.order.VremeTrajanjaServer !== '00:00:00:00'
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/sifarnici/spotovi/spotovi.component.ts